class customOtpLogin extends HTMLElement {
    constructor() {
        super();
        // console.log('otp login init');
        this.headerProfileButtons = document.querySelectorAll('.login-popup-button');
        // Phone login selectors
        this.phoneNumberInput = this.querySelector('#login-number-input');
        this.phoneNumberBtn = this.querySelector('#phnumber-login-button');
        this.phoneLoader = this.querySelector('#phnumber-loader');
        this.phoneBtnText = this.querySelector('#phnumber-btn-text');
        this.countryCodeSelector = this.querySelector('#custom-country-code-selector');
        // Email login selectors
        this.emailInput = this.querySelector('#login-email-input');
        this.emailBtn = this.querySelector('#email-login-button');
        this.emailLoader = this.querySelector('#email-loader');
        this.emailBtnText = this.querySelector('#email-btn-text');
        // Common selectors
        this.closeBtn = this.querySelector('.close-button');
        this.errorWrapper = this.querySelector('.error-wrapper');
        this.otpContainer = this.querySelector('#otp-container-wrapper');
        this.otpInputs = this.querySelectorAll('#otp-container-form .otp-container input');
        this.otpSubmitBtn = this.querySelector('#otp-verify-button')
        this.phoneNumberForm = this.querySelector('.phoneNumber-form');
        this.emailForm = this.querySelector('#email-login-form')
        this.otpVerifyLoader = this.querySelector('#otp-verify-loader');
        this.otpVerifyText = this.querySelector('#otp-verify-text');
        this.phoneEmailInputWrapper = this.querySelector('.phone-email-wrapper');
        // Resend OTP selectors
        this.resendOtpButton = this.querySelector('#resend-otp-button');
        this.resendOtpText = this.querySelector('#resend-otp-text');
        this.resendTimer = this.querySelector('#resend-timer');
        this.timerCountdown = this.querySelector('#timer-countdown');
        // Signup selectors
        this.signupForm = this.querySelector('.signup-form');
        this.signupNameInput = this.querySelector('#name-input');
        this.signupEmailInput = this.querySelector('#signup-email-input');
        this.signupPhoneInput = this.querySelector('#sign-number-input');
        this.signupCountryCodeSelector = this.querySelector('#signup-country-code-selector');
        this.signupEmailConsentInput = this.querySelector('#signup-email-consent-input');
        this.signupBtn = this.querySelector('#signup-button');
        this.signupBtnText = this.querySelector('#signup-btn-text');
        this.signupLoader = this.querySelector('#signup-loader');

        // OTP user info display
        this.otpUserInfo = this.querySelector('#otp-user-info');
        this.lastLoginType = null; // 'phone' or 'email'
        this.lastLoginValue = '';
        this.lastCountryCode = '+91';
        // Timer variables
        this.resendTimerInterval = null;
        this.resendTimerDuration = 60; // 60 seconds

        // Toggle login method buttons
        this.showPhoneLoginBtn = this.querySelector('#show-phone-login');
        this.showEmailLoginBtn = this.querySelector('#show-email-login');
        this.phoneLoginForm = this.querySelector('#phone-login-form');
        this.emailLoginForm = this.querySelector('#email-login-form');

        // success wrappers selectors
        this.loginSuccessWrapper = this.querySelector('.login-success-wrapper');
        this.loginSuccessTitle = this.querySelector('.login-success-title');
        this.loginSuccessSvgWrapper = this.querySelector('.login-success-svg-wrapper');
        this.registerInProgressSvgWrapper = this.querySelector('.register-in-progress-svg-wrapper');
        this.emailMapContainer = this.querySelector('.email-map-container');
        this.noEmailText = this.querySelector(".no-email-text");
        this.noPhoneText = this.querySelector(".no-phone-text");
    }

    connectedCallback() {
        // Signup button event
        if (this.signupBtn) {
            this.signupBtn.addEventListener('click', () => {
                this.handleSignup();
            });
        }
        if (this.headerProfileButtons) {            
            this.headerProfileButtons.forEach((headerProfileButton)=>{
                headerProfileButton.addEventListener('click', ()=>{
                    this.openLoginModal();
                })
            })
        }

        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => {
                this.closeLoginModal();
            })
        }

        // Toggle login method logic
        if (this.showPhoneLoginBtn && this.showEmailLoginBtn && this.phoneLoginForm && this.emailLoginForm) {
            this.showPhoneLoginBtn.addEventListener('click', () => {
                this.clearErrorWrapper();
                this.showPhoneLoginBtn.classList.add('active');
                this.showEmailLoginBtn.classList.remove('active');
                this.phoneLoginForm.classList.remove('hidden');
                this.emailLoginForm.classList.add('hidden');
            });
            this.showEmailLoginBtn.addEventListener('click', () => {
                this.clearErrorWrapper();
                this.showEmailLoginBtn.classList.add('active');
                this.showPhoneLoginBtn.classList.remove('active');
                this.emailLoginForm.classList.remove('hidden');
                this.phoneLoginForm.classList.add('hidden');
            });
        }

        if (this.phoneNumberBtn) {
            this.phoneNumberBtn.addEventListener('click', () => {
                this.handlePhoneLogin();
            });
        }

        if (this.emailBtn) {
            this.emailBtn.addEventListener('click', () => {
                this.handleEmailLogin();
            });
        }

        if (this.otpSubmitBtn) {
            // Bind a single routed click handler to prevent double-calls from mixed bindings
            if (!this._handleOtpSubmitClickRef) {
                this._handleOtpSubmitClickRef = (e) => {
                    e && e.preventDefault && e.preventDefault();
                    // During signup OTP phase, route to signup verify; otherwise, regular verify
                    // console.log(this._pendingSignupData);
                    if (this._pendingSignupData) {
                        // console.log(this._pendingSignupData.otpMode, "otpMode");
                    }
                    if (this._pendingSignupData && this._pendingSignupData.otpMode) {
                        // console.log('inside if rahid-1');


                        this.handleSignupOtpVerify();
                    } else {
                        // console.log('inside else rahid-2');

                        this.handleVerifyOtp();
                    }
                };
                this.otpSubmitBtn.addEventListener('click', this._handleOtpSubmitClickRef);
            }
        }

        if (this.resendOtpButton) {
            this.resendOtpButton.addEventListener('click', () => {
                this.handleResendOtp();
            });
        }

        //for otp containers
        if (this.otpInputs.length > 0) {
            this.otpInputs.forEach((input, index) => {
                input.addEventListener("input", () => {
                    if (input.value.length === 1 && index < this.otpInputs.length - 1) {
                        this.otpInputs[index + 1].focus();
                    }
                });

                input.addEventListener("keydown", (e) => {
                    if (e.key === "Backspace" && !input.value && index > 0) {
                        this.otpInputs[index - 1].focus();
                    }
                });
            });
        }
        // Ensure OTP back button exists and wire its handler
        this.ensureOtpBackButton();
        // Ensure signup & email-map back buttons exist
        this.ensureSignupBackButton();
        this.ensureEmailMapBackButton();
        // Attach handler for the email-map-container signup button
        const emailMapSignupBtn = this.querySelector('#email-map-container-signup-button');
        if (emailMapSignupBtn) {
            emailMapSignupBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleEmailMapContainerSignup();
            });
        }
    }

    /**
     * Ensure there is a back button inside the otp container to navigate back
     */
    ensureOtpBackButton() {
        if (!this.otpContainer) return;

        // Look for an existing back button
        let backBtn = this.otpContainer.querySelector('.otp-back-button');
        if (!backBtn) {
            backBtn = document.createElement('button');
            backBtn.type = 'button';
            backBtn.className = 'otp-back-button';
            backBtn.setAttribute('aria-label', 'Go back');
            // Add inline SVG + label for better UI
            backBtn.innerHTML = `
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M15 18l-6-6 6-6" stroke="#008060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="otp-back-button-label">Back</span>
            `;
            // Minimal styling to match existing UI (kept simple)
            backBtn.style.background = 'none';
            backBtn.style.border = 'none';
            backBtn.style.color = '#333';
            backBtn.style.cursor = 'pointer';
            backBtn.style.fontSize = '0.95em';
            backBtn.style.marginRight = '8px';

            // Insert at the top of otpContainer (before form) if possible
            const form = this.otpContainer.querySelector('#otp-container-form');
            if (form) this.otpContainer.insertBefore(backBtn, form);
            else this.otpContainer.appendChild(backBtn);
        }

        // Attach handler (avoid duplicate listeners)
        if (!backBtn._otpBackHandler) {
            backBtn._otpBackHandler = (e) => {
                e && e.preventDefault && e.preventDefault();
                // Clear any visible errors before navigating away
                this.clearErrorWrapper && this.clearErrorWrapper();
                this.handleBackFromOtp();
            };
            backBtn.addEventListener('click', backBtn._otpBackHandler);
        }
    }

    /**
     * Handler to navigate back from OTP screen to the appropriate previous view
     */
    handleBackFromOtp() {
        // Clear any resend timer
        this.clearResendTimer();

        // If in signup OTP flow, go back to signup form or email-map as appropriate
        if (this._pendingSignupData && this._pendingSignupData.otpMode) {
            // If came from email-map
            if (this._pendingSignupData.fromEmailMap && this.emailMapContainer) {
                this.otpContainer.classList.add('hidden');
                this.emailMapContainer.classList.remove('hidden');
                return;
            }
            // Otherwise show signup form and keep pending data intact
            this.otpContainer.classList.add('hidden');
            if (this.signupForm) this.signupForm.classList.remove('hidden');
            return;
        }

        // Regular login flow: show phone/email entry depending on lastLoginType
        this.otpContainer.classList.add('hidden');
        if (this.phoneEmailInputWrapper) this.phoneEmailInputWrapper.classList.remove('hidden');
        if (this.lastLoginType === 'phone') {
            if (this.phoneNumberForm) this.phoneNumberForm.classList.remove('hidden');
            if (this.emailForm) this.emailForm.classList.add('hidden');
            if (this.phoneNumberInput) this.phoneNumberInput.focus();
        } else if (this.lastLoginType === 'email') {
            if (this.emailForm) this.emailForm.classList.remove('hidden');
            if (this.phoneNumberForm) this.phoneNumberForm.classList.add('hidden');
            if (this.emailInput) this.emailInput.focus();
        } else {
            // No lastLoginType - default to showing phone/email wrapper
            if (this.phoneNumberForm) this.phoneNumberForm.classList.remove('hidden');
            if (this.emailForm) this.emailForm.classList.add('hidden');
        }
    }

    async handlePhoneLogin() {
        const mobileNumber = this.phoneNumberInput.value;
        const countryCode = this.countryCodeSelector ? this.countryCodeSelector.value : "+91";

        try {
            if (this.phoneNumberBtn) this.phoneNumberBtn.disabled = true;
            this.phoneLoader && this.phoneLoader.classList.remove('hidden');
            this.phoneBtnText && this.phoneBtnText.classList.add('hidden');
            // get captcha token
            const recaptchaToken = await this.getCaptcha();

            // call exposed function
            const response = await anthersCustomerLogin({
                type: "sendOtp",
                device: "phone",
                payload: {
                    mobileNumber,
                    countryCode,
                    recaptchaToken,
                    recaptchaVersion: "V3",
                }
            });


            if (response.status === 200) {
                // Show OTP input box
                this.otpContainer.classList.remove('hidden');
                // Reset OTP inputs when showing the OTP container
                this.clearOtpInputs();
                this.phoneNumberForm.classList.add('hidden');
                // Clear any previous error state
                if (this.errorWrapper) {
                    this.errorWrapper.textContent = '';
                    this.errorWrapper.classList.add('hidden');
                }
                // Hide phone/email input wrapper
                if (this.phoneEmailInputWrapper) this.phoneEmailInputWrapper.classList.add('hidden');
                // Show phone number above OTP with edit button
                this.lastLoginType = 'phone';
                this.lastLoginValue = mobileNumber;
                this.lastCountryCode = countryCode;
                this.renderOtpUserInfo();
                // Start resend timer
                this.startResendTimer();
            } else {
                if (response.response === "Failed verification") {
                    this.errorNotificationTrigger();
                }
                this.errorWrapper.textContent = response.response;
                this.errorWrapper.classList.remove('hidden');
            }

            // console.log("OTP Sent Response:", response);
            // console.log(response.response, 'message');
            this.phoneLoader && this.phoneLoader.classList.add('hidden');
            this.phoneBtnText && this.phoneBtnText.classList.remove('hidden');

        } catch (err) {
            console.error("Error sending OTP:", err);
        } finally {
            if (this.phoneNumberBtn) this.phoneNumberBtn.disabled = false;
        }
    }

    async handleEmailLogin() {
        const email = this.emailInput ? this.emailInput.value.trim() : '';

        // Validate email before proceeding. Use the stricter validateEmail check.
        if (!this.validateEmail(email)) {
            this.showSignupError('Please enter a valid email address.');
            return;
        }
        try {
            if (this.emailBtn) this.emailBtn.disabled = true;
            this.emailLoader && this.emailLoader.classList.remove('hidden');
            this.emailBtnText && this.emailBtnText.classList.add('hidden');
            // get captcha token
            const recaptchaToken = await this.getCaptcha();

            // call exposed function for email OTP
            const response = await anthersCustomerLogin({
                type: "sendOtp",
                device: "email",
                payload: {
                    email: email,
                    recaptchaToken: recaptchaToken,
                    recaptchaVersion: "V3",
                }
            });

            // Example: handle response and errors
            if (response.status === 200) { 
                // Show OTP input box
                this.otpContainer.classList.remove('hidden');
                // Reset OTP inputs when showing the OTP container
                this.clearOtpInputs();
                this.emailForm.classList.add('hidden');
                // Clear any previous error state
                if (this.errorWrapper) {
                    this.errorWrapper.textContent = '';
                    this.errorWrapper.classList.add('hidden');
                }
                // Hide phone/email input wrapper
                if (this.phoneEmailInputWrapper) this.phoneEmailInputWrapper.classList.add('hidden');
                // Show email above OTP with edit button
                this.lastLoginType = 'email';
                this.lastLoginValue = email;
                this.renderOtpUserInfo();
                // Start resend timer
                this.startResendTimer();
            } else {
                if (response.response === "Failed verification") {
                    this.errorNotificationTrigger();
                }
                this.errorWrapper.textContent = response.response;
                this.errorWrapper.classList.remove('hidden');
            }

            this.emailLoader && this.emailLoader.classList.add('hidden');
            this.emailBtnText && this.emailBtnText.classList.remove('hidden');
        } catch (err) {
            this.emailLoader && this.emailLoader.classList.add('hidden');
            this.emailBtnText && this.emailBtnText.classList.remove('hidden');
            console.error("Error with email login:", err);
        } finally {
            if (this.emailBtn) this.emailBtn.disabled = false;
        }
    }

    renderOtpUserInfo() {
        if (!this.otpUserInfo) return;
        // Clear
        this.otpUserInfo.innerHTML = '';
        if (!this.lastLoginValue) return;
        // Label
        const label = document.createElement('span');
        label.textContent = this.lastLoginType === 'phone' ? this.lastLoginValue : this.lastLoginValue;
        label.style.fontWeight = '500';
        label.style.letterSpacing = '0.01em';
        // Edit button
        const editBtn = document.createElement('button');
        editBtn.textContent = 'Edit';
        editBtn.type = 'button';
        editBtn.style.background = 'none';
        editBtn.style.border = 'none';
        editBtn.style.color = '#008060';
        editBtn.style.fontWeight = '500';
        editBtn.style.cursor = 'pointer';
        editBtn.style.marginLeft = '8px';
        editBtn.style.fontSize = '0.98em';
        editBtn.addEventListener('click', () => {
            this.handleEditLoginValue();
        });
        this.otpUserInfo.appendChild(label);
        this.otpUserInfo.appendChild(editBtn);
    }

    handleEditLoginValue() {
        // clear error wrapper
        this.clearErrorWrapper()
        // Hide OTP, show correct input, restore value
        this.otpContainer.classList.add('hidden');
        // Clear timer when editing login value
        this.clearResendTimer();

        // Check if we're in signup flow (have pending signup data)
        if (this._pendingSignupData) {
            // If flow originated from email-map, go back to email-map container
            if (this._pendingSignupData.fromEmailMap && this.emailMapContainer) {
                this.emailMapContainer.classList.remove('hidden');
                // Repopulate fields inside email-map container
                const nameInput = this.emailMapContainer.querySelector('#name-input');
                const emailInput = this.emailMapContainer.querySelector('#signup-email-input');
                if (nameInput && this._pendingSignupData.name) nameInput.value = this._pendingSignupData.name;
                if (emailInput && this._pendingSignupData.email) emailInput.value = this._pendingSignupData.email;
                const consentInput = this.emailMapContainer.querySelector('#signup-email-consent-input');
                if (consentInput && typeof this._pendingSignupData.consent !== 'undefined') {
                    consentInput.checked = !!this._pendingSignupData.consent;
                }
                return;
            }
            // Otherwise, go back to signup form
            this.signupForm.classList.remove('hidden');

            // Restore original OTP submit button behavior
            if (this._originalOtpSubmitListener) {
                this.otpSubmitBtn.onclick = this._originalOtpSubmitListener;
            }

            // Restore signup form values
            if (this.signupNameInput && this._pendingSignupData.name) {
                this.signupNameInput.value = this._pendingSignupData.name;
            }

            // Handle email field based on original verification method
            // console.log(this.signupEmailInput, 'this.signupEmailInput');
            // console.log(this._pendingSignupData, 'this._pendingSignupData');


            if (this.signupEmailInput && this._pendingSignupData.email) {
                this.signupEmailInput.value = this._pendingSignupData.email;
                // If original method was email, keep it locked (readonly)
                if (this._pendingSignupData.method === 'phone') {
                    this.signupEmailInput.readOnly = true;
                    this.signupEmailInput.parentElement.style.display = '';
                } else {
                    this.signupEmailInput.readOnly = false;
                    this.signupEmailInput.parentElement.style.display = '';
                }
            }

            // Handle phone field based on original verification method
            if (this.signupPhoneInput && this._pendingSignupData.phone) {
                this.signupPhoneInput.value = this._pendingSignupData.phone;
                // If original method was phone, keep it locked (readonly)
                if (this._pendingSignupData.method === 'email') {
                    this.signupPhoneInput.readOnly = true;
                    this.signupPhoneInput.parentElement.style.display = '';
                } else {
                    this.signupPhoneInput.readOnly = false;
                    this.signupPhoneInput.parentElement.style.display = '';
                }
            }

            if (this.signupCountryCodeSelector && this._pendingSignupData.countryCode) {
                this.signupCountryCodeSelector.value = this._pendingSignupData.countryCode;
            }
            if (this.signupEmailConsentInput) {
                this.signupEmailConsentInput.checked = this._pendingSignupData.consent;
            }

            // Keep pending signup data to preserve the original verification method
            // Don't clear _pendingSignupData here as we need it to maintain the flow
        } else {
            // Regular login flow, show phone/email input wrapper
            if (this.phoneEmailInputWrapper) this.phoneEmailInputWrapper.classList.remove('hidden');
            if (this.lastLoginType === 'phone') {
                this.phoneNumberForm.classList.remove('hidden');
                this.emailForm.classList.add('hidden');
                this.phoneNumberInput.value = this.lastLoginValue;
                this.phoneNumberInput.focus();
            } else if (this.lastLoginType === 'email') {
                this.emailForm.classList.remove('hidden');
                this.phoneNumberForm.classList.add('hidden');
                this.emailInput.value = this.lastLoginValue;
                this.emailInput.focus();
            }
        }
    }

    async handleVerifyOtp() {
        // console.log('called handleVerifyOtp....');
        this.clearErrorWrapper()

        // get OTP value from all input boxes
        const otp = Array.from(this.otpInputs).map(input => input.value).join("");

        if (otp.length !== this.otpInputs.length) {
            this.showSignupError("Incomplete OTP");
            console.error("Incomplete OTP");
            return;
        }

        try {
            if (this.otpSubmitBtn) this.otpSubmitBtn.disabled = true;
            this.otpVerifyLoader && this.otpVerifyLoader.classList.remove('hidden');
            this.otpVerifyText && this.otpVerifyText.classList.add('hidden');
            const response = await anthersCustomerLogin({
                type: "verifyOtp",
                payload: {
                    otp: otp,
                    skipCustomerMapping: true
                }
            });

            // console.log("Verify OTP Response:", response);
            // console.log(response.code, 'response code');

            if (response.code === "AER001") {
                // User not registered, show signup
                this.showSignupFormAfterOtp();
                return;
            } else if (response.code === "AER002") {
                this.noEmailText.classList.remove("hidden");
                this.showSignupFormAfterOtp();
                return;
            }
            else if (response.response === "You haven't added a phone number yet, Add it to get real time delivery updates") {
                this.noPhoneText.classList.remove("hidden");
                this.showSignupFormAfterOtp();
                return;
            } else if (response.code === "AER003") {
                // console.log('in condition AER003 - 1');
                
                // Hide OTP container
                if (this.otpContainer) this.otpContainer.classList.add('hidden');
                // Show signup form instead of email-map-container
                if (this.signupForm) {
                    this.signupForm.classList.remove('hidden');
                    // Restore last login value and pending signup data
                    if (!this._pendingSignupData) this._pendingSignupData = {};
                    if (this.lastLoginType === 'phone') {
                        this._pendingSignupData.method = 'phone';
                        if (this.signupPhoneInput) {
                            this.signupPhoneInput.value = this.lastLoginValue || '';
                            this.signupPhoneInput.readOnly = true;
                        }
                        if (this.signupEmailInput) {
                            this.signupEmailInput.value = '';
                            this.signupEmailInput.readOnly = false;
                            this.signupEmailInput.parentElement.style.display = '';
                        }
                    } else if (this.lastLoginType === 'email') {
                        this._pendingSignupData.method = 'email';
                        if (this.signupEmailInput) {
                            this.signupEmailInput.value = this.lastLoginValue || '';
                            this.signupEmailInput.readOnly = true;
                        }
                        if (this.signupPhoneInput) {
                            this.signupPhoneInput.value = '';
                            this.signupPhoneInput.readOnly = false;
                            this.signupPhoneInput.parentElement.style.display = '';
                        }
                    }
                }
            } else if (response.status === 500) {
                this.showSignupError(response.response || 'OTP verification failed.');
            }
            else {
                // console.log('inside else....');

                if (this.errorWrapper) {
                    this.errorWrapper.textContent = '';
                    this.errorWrapper.classList.add('hidden');
                }

                this.otpContainer.classList.add('hidden');
                // Clear any previous errors before showing success
                this.clearErrorWrapper();
                this.loginSuccessTitle.textContent = 'You are successfully logged in';
                this.loginSuccessWrapper.classList.remove('hidden');
                this.loginSuccessSvgWrapper.classList.remove('hidden')
            }
            // 👉 handle success (set session, redirect, etc.)
        } catch (err) {
            console.error("Error verifying OTP:", err);
        } finally {
            this.otpVerifyLoader && this.otpVerifyLoader.classList.add('hidden');
            this.otpVerifyText && this.otpVerifyText.classList.remove('hidden');
            if (this.otpSubmitBtn) this.otpSubmitBtn.disabled = false;
        }
    }

    showSignupFormAfterOtp() {
        // console.log('called showSignupFormAfterOtp....');

        // Hide OTP and info
        this.otpContainer.classList.add('hidden');
        if (this.otpUserInfo) this.otpUserInfo.innerHTML = '';
        // Clear any shown errors when switching to signup
        this.clearErrorWrapper();
        // Clear timer when showing signup form
        this.clearResendTimer();
        // Show signup form
        if (this.signupForm) {
            this.signupForm.classList.remove('hidden');
        }
        // Track that we came from OTP verify to signup
        this._cameFromOtpVerify = true;

        // Store the original verification method for later reference
        if (!this._pendingSignupData) {
            this._pendingSignupData = {};
        }

        // Prefill and show/hide fields based on login type
        if (this.lastLoginType === 'phone') {
            // User logged in with phone, ask for email
            this._pendingSignupData.method = 'phone'; // Store original method
            if (this.signupPhoneInput) {
                // console.log('last login value phone number', this.lastLoginValue);

                this.signupPhoneInput.value = this.lastLoginValue;
                this.signupPhoneInput.readOnly = true;
            }
            if (this.signupEmailInput) {
                this.signupEmailInput.value = '';
                this.signupEmailInput.readOnly = false;
                this.signupEmailInput.parentElement.style.display = '';
            }
        } else if (this.lastLoginType === 'email') {
            // User logged in with email, ask for phone
            this._pendingSignupData.method = 'email'; // Store original method
            if (this.signupEmailInput) {
                // console.log('last login value email', this.lastLoginValue);


                this.signupEmailInput.value = this.lastLoginValue;
                this.signupEmailInput.readOnly = true;
            }
            if (this.signupPhoneInput) {
                this.signupPhoneInput.value = '';
                this.signupPhoneInput.readOnly = false;
                this.signupPhoneInput.parentElement.style.display = '';
            }
        }
    }

    async handleSignup() {
        // console.log('called handleSignup');
        // Validate name
        const name = this.signupNameInput ? this.signupNameInput.value.trim() : '';
        if (!name) {
            this.showSignupError('Please enter your name.');
            return;
        }
        // Capture both fields
        const phone = this.signupPhoneInput ? this.signupPhoneInput.value.trim() : '';
        let email = this.signupEmailInput ? this.signupEmailInput.value.trim() : '';
        // If input is blank, use the select value (priority order: input > select)
        if (!email) {
            const select = this.querySelector('.email-map-item-list select');
            if (select && select.value) {
                email = select.value;
                // Also reflect this new value in the input for consistency (optional)
                if (this.signupEmailInput) this.signupEmailInput.value = email;
            }
        }
        const countryCode = this.signupCountryCodeSelector ? this.signupCountryCodeSelector.value : '+91';
        const consent = this.signupEmailConsentInput ? this.signupEmailConsentInput.checked : false;
        // Decide which field is being newly entered
        let payloadField, deviceType, payloadData;
        // If phone is unlocked (new entry), validate and send OTP to phone
        if (this.signupPhoneInput && !this.signupPhoneInput.readOnly) {
            if (!this.validatePhone(phone)) {
                this.showSignupError('Please enter a valid phone number.');
                return;
            }
            // console.log(sessionStorage.getItem('sessionId'),'session id');
            
            payloadField = 'phone';
            deviceType = 'phone';
            payloadData = {
                mobileNumber: phone,
                countryCode: countryCode,
                sessionId: sessionStorage.getItem('sessionId')
                // captcha fields added below
            };
            // console.log(payloadData,'payloaddata---rahid');
            
        } else if (this.signupEmailInput && !this.signupEmailInput.readOnly) {
            if (!this.validateEmail(email)) {
                this.showSignupError('Please enter a valid email address.');
                return;
            }
            // console.log(sessionStorage.getItem('sessionId'),'session id');
            payloadField = 'email';
            deviceType = 'email';
            payloadData = {
                email: email,
                sessionId: sessionStorage.getItem('sessionId')
                // captcha fields added below
            };
        } else {
            this.showSignupError('No valid registration field to verify.');
            return;
        }
        // Always store BOTH, so use empty string if not set
        this._pendingSignupData = {
            name,
            email: email || '',
            phone: phone || '',
            countryCode,
            consent,
            method: payloadField // to inform OTP verification
        };
        // Show loader
        if (this.signupLoader) this.signupLoader.classList.remove('hidden');
        if (this.signupBtnText) this.signupBtnText.classList.add('hidden');
        if (this.signupBtn) this.signupBtn.disabled = true;
        try {
            const recaptchaToken = await this.getCaptcha();
            payloadData.recaptchaToken = recaptchaToken;
            payloadData.recaptchaVersion = "V3";
            const otpPayload = await anthersCustomerLogin({
                type: "sendOtp",
                device: deviceType,
                payload: payloadData
            });
            if (otpPayload.status === 200) {
                this.showSignupOtpInput(payloadField); // now 'phone' or 'email'
            } else {
                this.showSignupError(otpPayload.response || 'Failed to send OTP.');
            }
        } catch (err) {
            this.showSignupError('Signup OTP error.');
        }
        if (this.signupLoader) this.signupLoader.classList.add('hidden');
        if (this.signupBtnText) this.signupBtnText.classList.remove('hidden');
        if (this.signupBtn) this.signupBtn.disabled = false;
    }

    /**
     * Displays OTP input UI for signup.
     * @param {('phone'|'email')} mode
     */
    showSignupOtpInput(mode) {
        // Hide signup form, show OTP input (reuse the same OTP UI if possible)
        if (this.signupForm) this.signupForm.classList.add('hidden');
        this.otpContainer.classList.remove('hidden');
        // Hide any previous errors when showing OTP input
        this.clearErrorWrapper();
        // Tag the mode for later use
        this._pendingSignupData.otpMode = mode;
        // Reset OTP input fields
        this.clearOtpInputs();
        // Track and display user info (email or phone)
        if (mode === 'phone') {
            this.lastLoginType = 'phone';
            this.lastLoginValue = this._pendingSignupData.phone;
        } else if (mode === 'email') {
            this.lastLoginType = 'email';
            this.lastLoginValue = this._pendingSignupData.email;
        }
        this.renderOtpUserInfo();
        // Start resend timer for signup OTP
        this.startResendTimer();
        // Change submit behavior to OTP verify for signup:
        // No need to rebind here; routed click handler will call handleSignupOtpVerify based on state
    }

    /**
     * Handles signup OTP verification and registration.
     */
    async handleSignupOtpVerify() {
        // console.log('called handleSignupOtpVerify....');

        const otp = Array.from(this.otpInputs).map(input => input.value).join("");
        if (!otp || otp.length !== this.otpInputs.length) {
            this.showSignupError("Please enter the complete OTP.");
            return;
        }
        if (!this._pendingSignupData) return;
        try {
            if (this.otpSubmitBtn) this.otpSubmitBtn.disabled = true;
            if (this.otpVerifyLoader) this.otpVerifyLoader.classList.remove('hidden');
            if (this.otpVerifyText) this.otpVerifyText.classList.add('hidden');
            // if (this.otpContainer) this.otpContainer.classList.add('hidden');
            // console.log('adding hidden class to the otp contianer.................');
            let verifyPayload;
            if (this._pendingSignupData.otpMode === 'phone') {
                verifyPayload = await anthersCustomerLogin({
                    type: "verifyOtp",
                    payload: {
                        otp: otp,
                        mobileNumber: this._pendingSignupData.phone,
                        countryCode: this._pendingSignupData.countryCode,
                        skipCustomerMapping: false
                    }
                });
            } else {
                verifyPayload = await anthersCustomerLogin({
                    type: "verifyOtp",
                    payload: {
                        otp: otp,
                        email: this._pendingSignupData.email,
                        skipCustomerMapping: false
                    }
                });
            }

            // console.log(verifyPayload, 'verifyPayload....');

            if (verifyPayload.status == 200) {
                if (this.otpContainer) this.otpContainer.classList.add('hidden');
            }

            // AER001: Customer not exists, so proceed with registration
            if (verifyPayload && verifyPayload.code === 'AER001') {
                if (this.otpContainer) this.otpContainer.classList.add('hidden');
                // console.log('adding hidden class to the otp contianer.................');

                // console.log('inside AER001');
                this.signupForm.classList.add('hidden');
                // console.log(this._pendingSignupData.email, 'this._pendingSignupData.email');

                // console.log(this._pendingSignupData, 'this._pendingSignupData....AER001');




                // Show registering progress state
                // Clear any previous errors before showing registering state
                this.clearErrorWrapper();
                if (this.loginSuccessWrapper) this.loginSuccessWrapper.classList.remove('hidden');
                if (this.loginSuccessTitle) this.loginSuccessTitle.textContent = 'Registering in progress';
                if (this.registerInProgressSvgWrapper) this.registerInProgressSvgWrapper.classList.remove('hidden');
                if (this.loginSuccessSvgWrapper) this.loginSuccessSvgWrapper.classList.add('hidden');

                // console.log({
                //     name: this._pendingSignupData.name,
                //     email: this._pendingSignupData.email,
                //     mobile: this._pendingSignupData.phone,
                //     countryCode: this._pendingSignupData.countryCode,
                //     consent: this._pendingSignupData.consent
                // },'payload....AER001');


                // Call registration API with stored info
                const regResp = await anthersCustomerLogin({
                    type: "registerCustomer",
                    payload: {
                        name: this._pendingSignupData.name,
                        email: this._pendingSignupData.email,
                        mobile: this._pendingSignupData.phone,
                        countryCode: this._pendingSignupData.countryCode,
                        consent: this._pendingSignupData.consent
                    }
                });

                // console.log(this._pendingSignupData, 'this._pendingSignupData');


                // console.log(typeof (this._pendingSignupData.consent), this._pendingSignupData.consent, 'this._pendingSignupData.consent');




                // console.log('regResp', regResp);
                // console.log(this.otpContainer, 'after regResp logggg');

                if (regResp.status === 200) {
                    if (this.signupForm) this.signupForm.classList.add('hidden');
                    if (this.otpContainer) this.otpContainer.classList.add('hidden');
                    // Clear any prior errors and show success
                    this.clearErrorWrapper();
                    if (this.loginSuccessTitle) this.loginSuccessTitle.textContent = 'You are successfully registered';
                    if (this.loginSuccessWrapper) this.loginSuccessWrapper.classList.remove('hidden');
                    if (this.registerInProgressSvgWrapper) this.registerInProgressSvgWrapper.classList.add('hidden');
                    if (this.loginSuccessSvgWrapper) this.loginSuccessSvgWrapper.classList.remove('hidden');
                    if (this.otpContainer) this.otpContainer.classList.add('hidden');
                } else if (regResp.status === 500) {
                    // Retry once on server error with the same payload
                    const retryResp = await anthersCustomerLogin({
                        type: "registerCustomer",
                        payload: {
                            name: this._pendingSignupData.name,
                            email: this._pendingSignupData.email,
                            mobile: this._pendingSignupData.phone,
                            countryCode: this._pendingSignupData.countryCode,
                            consent: this._pendingSignupData.consent
                        }
                    });
                    this.showSignupError(retryResp.response || 'Signup failed.');
                } else {
                    this.showSignupError(regResp.response || 'Signup failed.');
                }
            } else if (verifyPayload.code === "AER002") {
                // console.log('inside AER002');
                
                // Proceed to register customer with stored data
                // if (this.loginSuccessWrapper) this.loginSuccessWrapper.classList.remove('hidden');
                // if (this.loginSuccessTitle) this.loginSuccessTitle.textContent = 'Registering in progress';
                // if (this.registerInProgressSvgWrapper) this.registerInProgressSvgWrapper.classList.remove('hidden');
                // if (this.loginSuccessSvgWrapper) this.loginSuccessSvgWrapper.classList.add('hidden');

                const regResp = await anthersCustomerLogin({
                    type: "registerCustomer",
                    payload: {
                        name: this._pendingSignupData.name,
                        email: this._pendingSignupData.email,
                        mobile: this._pendingSignupData.phone,
                        countryCode: this._pendingSignupData.countryCode,
                        consent: this._pendingSignupData.consent
                    }
                });

                // console.log(regResp,'regResp---');
                

                if (regResp.status === 200) {
                    if (this.signupForm) this.signupForm.classList.add('hidden');
                    if (this.otpContainer) this.otpContainer.classList.add('hidden');
                    
                    if (this.loginSuccessWrapper) this.loginSuccessWrapper.classList.remove('hidden');
                    if (this.loginSuccessTitle) this.loginSuccessTitle.textContent = 'Registering in progress';
                    if (this.registerInProgressSvgWrapper) this.registerInProgressSvgWrapper.classList.remove('hidden');
                    if (this.loginSuccessSvgWrapper) this.loginSuccessSvgWrapper.classList.add('hidden');

                    // Clear any prior errors and show success
                    this.clearErrorWrapper();
                    if (this.loginSuccessTitle) this.loginSuccessTitle.textContent = 'You are successfully registered';
                    if (this.loginSuccessWrapper) this.loginSuccessWrapper.classList.remove('hidden');
                    if (this.registerInProgressSvgWrapper) this.registerInProgressSvgWrapper.classList.add('hidden');
                    if (this.loginSuccessSvgWrapper) this.loginSuccessSvgWrapper.classList.remove('hidden');
                    if (this.otpContainer) this.otpContainer.classList.add('hidden');
                    // Clear pending signup data after successful registration
                    this._pendingSignupData = null;
                } else if (regResp.status === 500) {
                    // console.log('inside status 500');
                    
                    this.showSignupError(regResp.response || 'Signup failed.');
                } else {
                    this.showSignupError(regResp.response || 'Signup failed.');
                }
            }
            else if (verifyPayload.code === "AER003") {
                // Hide OTP container
                if (this.otpContainer) this.otpContainer.classList.add('hidden');
                // Directly register the customer with pending signup data
                if (this._pendingSignupData) {
                    // Show registering progress state
                    this.clearErrorWrapper();
                    if (this.loginSuccessWrapper) this.loginSuccessWrapper.classList.remove('hidden');
                    if (this.loginSuccessTitle) this.loginSuccessTitle.textContent = 'Registering in progress';
                    if (this.registerInProgressSvgWrapper) this.registerInProgressSvgWrapper.classList.remove('hidden');
                    if (this.loginSuccessSvgWrapper) this.loginSuccessSvgWrapper.classList.add('hidden');

                    const regResp = await anthersCustomerLogin({
                        type: "registerCustomer",
                        payload: {
                            name: this._pendingSignupData.name,
                            email: this._pendingSignupData.email,
                            mobile: this._pendingSignupData.phone,
                            countryCode: this._pendingSignupData.countryCode,
                            consent: this._pendingSignupData.consent
                        }
                    });

                    if (regResp.status === 200) {
                        if (this.signupForm) this.signupForm.classList.add('hidden');
                        if (this.otpContainer) this.otpContainer.classList.add('hidden');
                        this.clearErrorWrapper();
                        if (this.loginSuccessTitle) this.loginSuccessTitle.textContent = 'You are successfully registered';
                        if (this.loginSuccessWrapper) this.loginSuccessWrapper.classList.remove('hidden');
                        if (this.registerInProgressSvgWrapper) this.registerInProgressSvgWrapper.classList.add('hidden');
                        if (this.loginSuccessSvgWrapper) this.loginSuccessSvgWrapper.classList.remove('hidden');
                        if (this.otpContainer) this.otpContainer.classList.add('hidden');
                        this._pendingSignupData = null;
                    } else if (regResp.status === 500) {
                        this.showSignupError(regResp.response || 'Signup failed.');
                    } else {
                        this.showSignupError(regResp.response || 'Signup failed.');
                    }
                }

            }

            else if (
                verifyPayload &&
                verifyPayload.status === 200 &&
                this._pendingSignupData.otpMode === 'email' &&
                verifyPayload.response
            ) {
                // Email verified via email-map flow. Proceed to register with stored data (including original phone)
                // Clear any previous errors before showing registering state
                this.clearErrorWrapper();
                if (this.loginSuccessWrapper) this.loginSuccessWrapper.classList.remove('hidden');
                if (this.loginSuccessTitle) this.loginSuccessTitle.textContent = 'Registering in progress';
                if (this.registerInProgressSvgWrapper) this.registerInProgressSvgWrapper.classList.remove('hidden');
                if (this.loginSuccessSvgWrapper) this.loginSuccessSvgWrapper.classList.add('hidden');
                const regResp = await anthersCustomerLogin({
                    type: "registerCustomer",
                    payload: {
                        name: this._pendingSignupData.name,
                        email: this._pendingSignupData.email,
                        mobile: this._pendingSignupData.phone,
                        countryCode: this._pendingSignupData.countryCode,
                        consent: this._pendingSignupData.consent
                    }
                });

                // console.log(regResp, 'regResp....rahid');

                if (regResp.status === 200) {
                    // console.log('in status 200........');
                    
                    if (this.signupForm) this.signupForm.classList.add('hidden');
                    if (this.otpContainer) this.otpContainer.classList.add('hidden');
                    // Clear any prior errors and show success
                    this.clearErrorWrapper();
                    if (this.loginSuccessTitle) this.loginSuccessTitle.textContent = 'You are successfully registered';
                    if (this.loginSuccessWrapper) this.loginSuccessWrapper.classList.remove('hidden');
                    if (this.registerInProgressSvgWrapper) this.registerInProgressSvgWrapper.classList.add('hidden');
                    if (this.loginSuccessSvgWrapper) this.loginSuccessSvgWrapper.classList.remove('hidden');
                    if (this.otpContainer) this.otpContainer.classList.add('hidden');
                    // Clear pending signup data after successful registration
                    this._pendingSignupData = null;
                } else if (regResp.status === 500) {
                    // console.log('in status 500...');
                    this.showSignupError(regResp.response || 'Signup failed.');
                }
                else {
                    this.showSignupError(regResp.response || 'Signup failed.');
                }
                return;
            } else if (verifyPayload && verifyPayload.status === 200 && this._pendingSignupData.otpMode === 'phone') {
                // Existing phone (not email), treat as success (login etc or redirect)
                this.signupForm.classList.add('hidden');
                this.otpContainer.classList.add('hidden');
                // Optionally handle logged-in state here
                // Clear pending signup data after successful phone verification
                this._pendingSignupData = null;
            } else {
                // All other cases
                this.showSignupError(verifyPayload.response || 'OTP verification failed.');
            }
        } catch (e) {
            this.showSignupError('OTP verification error.');
        } finally {
            if (this.otpVerifyLoader) this.otpVerifyLoader.classList.add('hidden');
            if (this.otpVerifyText) this.otpVerifyText.classList.remove('hidden');
            if (this.otpSubmitBtn) this.otpSubmitBtn.disabled = false;
        }
        // NOTE: do not clear this._pendingSignupData here unconditionally.
        // Keep pending signup data intact on verification failure so the user
        // can retry OTP without losing the registration context.
    }

    async handleSignupPhoneOtpVerify(phone, countryCode) {
        const otp = this.signupPhoneOtpInput.value.trim();
        if (!otp || otp.length < 4) {
            this.showSignupError('Please enter a valid OTP.');
            return;
        }
        try {
            const response = await anthersCustomerLogin({
                type: "verifyOtp",
                payload: {
                    otp: otp,
                    mobileNumber: phone,
                    countryCode: countryCode,
                    skipCustomerMapping: true
                }
            });
            if (response.status === 200) {
                this.signupPhoneInput.dataset.verified = '1';
                this.showSignupError('Phone number verified. Registering...');
                this.signupPhoneOtpInput.disabled = true;
                this.signupPhoneOtpBtn.disabled = true;
                // Immediately register customer after phone is verified
                await this.finalizeSignupAfterPhoneOtp();
            } else {
                this.showSignupError(response.response || 'OTP verification failed.');
            }
        } catch (err) {
            this.showSignupError('OTP verification error.');
        }
    }

    async finalizeSignupAfterPhoneOtp() {
        // console.log('called finalizeSignupAfterPhoneOtp');

        // Use the same logic as handleSignup, but skip OTP step
        const name = this.signupNameInput ? this.signupNameInput.value.trim() : '';
        const email = this.signupEmailInput ? this.signupEmailInput.value.trim() : '';
        const phone = this.signupPhoneInput ? this.signupPhoneInput.value.trim() : '';
        const countryCode = this.signupCountryCodeSelector ? this.signupCountryCodeSelector.value : '+91';
        const consent = this.signupEmailConsentInput ? this.signupEmailConsentInput.checked : false;
        if (this.signupLoader) this.signupLoader.classList.remove('hidden');
        if (this.signupBtnText) this.signupBtnText.classList.add('hidden');
        if (this.signupBtn) this.signupBtn.disabled = true;
        try {
            const response = await anthersCustomerLogin({
                type: "registerCustomer",
                payload: {
                    name: name,
                    email: email,
                    mobile: phone,
                    countryCode: countryCode,
                    consent: consent
                }
            });
            if (response.status === 200) {
                // Clear any prior errors and hide signup form
                this.clearErrorWrapper();
                this.signupForm.classList.add('hidden');
                // Optionally, show a success message or redirect
            } else {
                this.showSignupError(response.response || 'Signup failed.');
            }
        } catch (err) {
            this.showSignupError('Signup error.');
        } finally {
            if (this.signupLoader) this.signupLoader.classList.add('hidden');
            if (this.signupBtnText) this.signupBtnText.classList.remove('hidden');
            if (this.signupBtn) this.signupBtn.disabled = false;
        }
    }

    async handleEmailMapContainerSignup() {
        // console.log('called handleEmailMapContainerSignup');

        // Get the correct inputs inside .email-map-container
        const emailMapContainer = this.querySelector('.email-map-container');
        const nameInput = emailMapContainer ? emailMapContainer.querySelector('#name-input') : null;
        const emailInput = emailMapContainer ? emailMapContainer.querySelector('#signup-email-input') : null;
        // const consentInput = emailMapContainer ? emailMapContainer.querySelector('#signup-email-consent-input') : null;
        // Scoped register button + its loader/text inside email-map container
        const emailMapSignupBtn = this.querySelector('#email-map-container-signup-button');
        const emailMapBtnText = emailMapContainer ? emailMapContainer.querySelector('#signup-btn-text') : null;
        const emailMapBtnLoader = emailMapContainer ? emailMapContainer.querySelector('#signup-loader') : null;
        const name = nameInput ? nameInput.value.trim() : '';
        let email = emailInput ? emailInput.value.trim() : '';

        // Priority: input > select
        if (!email) {
            const select = this.querySelector('.email-map-item-list select');
            if (select && select.value) {
                email = select.value;
            }
        }
        // console.log('Final registration email:', email); // <-- debug line after input/select fallback
        // Use other stored fields (phone, cc, consent) if needed
        const phone = (this._pendingSignupData && this._pendingSignupData.phone)
            ? this._pendingSignupData.phone.trim()
            : (this.lastLoginType === 'phone' ? (this.lastLoginValue || '').trim() : '');
        const countryCode = (this._pendingSignupData && this._pendingSignupData.countryCode)
            ? this._pendingSignupData.countryCode
            : (this.lastCountryCode || (this.signupCountryCodeSelector ? this.signupCountryCodeSelector.value : '+91'));
        // Read consent specifically from the email-map container's checkbox
        // const consent = consentInput ? consentInput.checked : false;

        // Minimal validation
        if (!name) {
            this.showSignupError('Please enter your name.');
            return;
        }
        if (!email) {
            this.showSignupError('Please select or enter your email.');
            return;
        }

        // Build pending data for OTP + registration
        this._pendingSignupData = {
            name,
            email,
            phone,
            countryCode,
            consent: true,
            method: 'email',
            otpMode: 'email',
            fromEmailMap: true
        };

        // Show loader on email-map container button (hide text, disable button)
        if (emailMapBtnLoader) emailMapBtnLoader.classList.remove('hidden');
        if (emailMapBtnText) emailMapBtnText.classList.add('hidden');
        if (emailMapSignupBtn) emailMapSignupBtn.disabled = true;

        // console.log(sessionStorage.getItem('sessionId'),'session id');
        

        // Send OTP to the chosen email first
        try {
            const recaptchaToken = await this.getCaptcha();
            const otpSendResp = await anthersCustomerLogin({
                type: "sendOtp",
                device: "email",
                payload: {
                    email: email,
                    recaptchaToken: recaptchaToken,
                    recaptchaVersion: "V3",
                    sessionId: sessionStorage.getItem('sessionId')
                }
            });
            // console.log('email-map sendOtp response:', otpSendResp);
            if (otpSendResp && otpSendResp.status === 200) {
                // Hide email-map container and show OTP UI for email verification
                if (this.emailMapContainer) this.emailMapContainer.classList.add('hidden');
                this.showSignupOtpInput('email');
            } else {
                this.showSignupError(otpSendResp?.response || 'Failed to send OTP.');
            }
        } catch (err) {
            console.error('email-map sendOtp error:', err);
            this.showSignupError('Signup OTP error.');
        } finally {
            // Restore button UI state
            if (emailMapBtnLoader) emailMapBtnLoader.classList.add('hidden');
            if (emailMapBtnText) emailMapBtnText.classList.remove('hidden');
            if (emailMapSignupBtn) emailMapSignupBtn.disabled = false;
        }
    }

    showSignupError(msg) {
        if (this.errorWrapper) {
            this.errorWrapper.textContent = msg;
            this.errorWrapper.classList.remove('hidden');
        }
    }

    /**
     * Clears and hides the error wrapper element
     */
    clearErrorWrapper() {
        if (this.errorWrapper) {
            this.errorWrapper.textContent = '';
            this.errorWrapper.classList.add('hidden');
        }
    }

    /**
     * Clear and reset OTP input fields
     */
    clearOtpInputs() {
        if (!this.otpInputs || this.otpInputs.length === 0) return;
        this.otpInputs.forEach(input => {
            input.value = '';
            input.classList.remove('filled');
        });
        try {
            if (this.otpInputs[0]) this.otpInputs[0].focus();
        } catch (e) { }
    }

    /**
     * Add a back button to the signup form that returns to the OTP container
     */
    ensureSignupBackButton() {
        if (!this.signupForm) return;
        let btn = this.signupForm.querySelector('.signup-back-button');
        if (!btn) {
            btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'signup-back-button otp-back-button';
            btn.setAttribute('aria-label', 'Back to OTP');
            btn.innerHTML = `
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M15 18l-6-6 6-6" stroke="#008060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Back</span>
            `;
            this.signupForm.insertBefore(btn, this.signupForm.firstChild);
        }
        if (!btn._handler) {
            btn._handler = (e) => {
                e && e.preventDefault && e.preventDefault();
                // clear errors and timers
                this.clearErrorWrapper();
                this.clearResendTimer();
                // If user came from OTP verify, go to initial email entry screen
                if (this._cameFromOtpVerify) {
                    if (this.signupForm) this.signupForm.classList.add('hidden');
                    if (this.phoneEmailInputWrapper) this.phoneEmailInputWrapper.classList.remove('hidden');
                    if (this.emailForm) {
                        this.emailForm.classList.remove('hidden');
                        this.emailInput && (this.emailInput.value = '');
                        this.emailInput && this.emailInput.focus();
                    }
                    if (this.phoneNumberForm) this.phoneNumberForm.classList.add('hidden');
                    this._cameFromOtpVerify = false;
                } else {
                    // hide signup, show otp container
                    if (this.signupForm) this.signupForm.classList.add('hidden');
                    if (this.otpContainer) {
                        this.otpContainer.classList.remove('hidden');
                        this.clearOtpInputs();
                    }
                }
            };
            btn.addEventListener('click', btn._handler);
        }
    }

    /**
     * Add a back button to the email-map container that returns to the OTP container
     */
    ensureEmailMapBackButton() {
        if (!this.emailMapContainer) return;
        let btn = this.emailMapContainer.querySelector('.emailmap-back-button');
        if (!btn) {
            btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'emailmap-back-button otp-back-button';
            btn.setAttribute('aria-label', 'Back to OTP');
            btn.innerHTML = `
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M15 18l-6-6 6-6" stroke="#008060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Back</span>
            `;
            // Insert at top of email map container
            this.emailMapContainer.insertBefore(btn, this.emailMapContainer.firstChild);
        }
        if (!btn._handler) {
            btn._handler = (e) => {
                e && e.preventDefault && e.preventDefault();
                this.clearErrorWrapper();
                this.clearResendTimer();
                if (this.emailMapContainer) this.emailMapContainer.classList.add('hidden');
                if (this.otpContainer) {
                    this.otpContainer.classList.remove('hidden');
                    this.clearOtpInputs();
                }
            };
            btn.addEventListener('click', btn._handler);
        }
    }

    validateEmail(email) {
        // Require an '@' and a '.com' TLD (case-insensitive). Also ensure no leading/trailing spaces.
        if (!email || typeof email !== 'string') return false;
        const trimmed = email.trim();
        // Basic check: contains '@' and ends with .com (case-insensitive)
        const hasAt = trimmed.indexOf('@') > 0; // not at position 0
        const endsWithCom = /\.com$/i.test(trimmed);
        return hasAt;
    }

    validatePhone(phone) {
        // Simple phone validation (10 digits)
        return /^\d{10}$/.test(phone);
    }

    getCaptcha() {
        return new Promise((resolve, reject) => {
            grecaptcha.ready(function () {
                grecaptcha.execute('6Le749grAAAAAHGBgoTF8GJpqqNZwrzubbVHfnZY', { action: 'submit' })
                    .then(function (token) {
                        resolve(token);
                    })
                    .catch(err => reject(err));
            });
        });
    }

    openLoginModal() {
        this.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    closeLoginModal() {
        this.classList.remove('active');
        // Clear any running timer when modal is closed
        this.clearResendTimer();
        document.body.style.overflow = '';
    }

    /**
     * Starts the resend OTP timer
     */
    startResendTimer() {
        // Clear any existing timer
        this.clearResendTimer();

        // Disable button and show timer
        if (this.resendOtpButton) this.resendOtpButton.disabled = true;
        if (this.resendOtpText) this.resendOtpText.classList.add('hidden');
        if (this.resendTimer) this.resendTimer.classList.remove('hidden');

        let timeLeft = this.resendTimerDuration;
        if (this.timerCountdown) this.timerCountdown.textContent = timeLeft;

        this.resendTimerInterval = setInterval(() => {
            timeLeft--;
            if (this.timerCountdown) this.timerCountdown.textContent = timeLeft;

            if (timeLeft <= 0) {
                this.clearResendTimer();
                this.enableResendButton();
            }
        }, 1000);
    }

    /**
     * Clears the resend timer
     */
    clearResendTimer() {
        if (this.resendTimerInterval) {
            clearInterval(this.resendTimerInterval);
            this.resendTimerInterval = null;
        }
    }

    /**
     * Enables the resend button
     */
    enableResendButton() {
        if (this.resendOtpButton) this.resendOtpButton.disabled = false;
        if (this.resendOtpText) this.resendOtpText.classList.remove('hidden');
        if (this.resendTimer) this.resendTimer.classList.add('hidden');
    }

    /**
     * Handles resend OTP functionality
     */
    async handleResendOtp() {
        if (!this.resendOtpButton || this.resendOtpButton.disabled) return;

        try {
            // Disable button immediately
            this.resendOtpButton.disabled = true;

            // Call the resend OTP API
            const response = await anthersCustomerLogin({ type: "resendOtp" });

            // console.log({ response });


            if (response && response.status === 200) {
                // Show success message briefly
                const originalText = this.resendOtpText.textContent;
                this.resendOtpText.textContent = 'OTP Sent!';
                this.resendOtpButton.disabled = false;

                // Reset text after 2 seconds
                setTimeout(() => {
                    this.resendOtpText.textContent = originalText;
                    this.startResendTimer();
                }, 2000);
            } else {
                // Handle error
                this.resendOtpButton.disabled = false;
                this.showSignupError(response?.response || 'Failed to resend OTP. Please try again.');
            }
        } catch (error) {
            console.error('Error resending OTP:', error);
            this.resendOtpButton.disabled = false;
            this.showSignupError('Failed to resend OTP. Please try again.');
        }
    }

    errorNotificationTrigger() {
        console.log('called errorNotificationTrigger');
        
        fetch('https://script.google.com/macros/s/AKfycbwSR9gJYbcpIdo0tRP7Aa5KthGJV_iPvv7MF5SFkfZQSezYdwWcNtIMjMCEvY4TmNhl9A/exec', {
            method: 'POST',
        })
            .then(res => res.json())
            .then(data => console.log("Saved:", data))
            .catch(err => console.error(err));
    }
}

customElements.define("custom-otp-login", customOtpLogin);